import { formatMonthYear } from '../../utils/formatters';

const ChevronLeftIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className="h-4 w-4">
    <path d="M15 6l-6 6 6 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ChevronRightIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className="h-4 w-4">
    <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const TodayIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className="h-3.5 w-3.5">
    <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.6" />
    <path d="M3 9h18M8 3v4M16 3v4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

function NavButton({ onClick, disabled, label, children }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      className="inline-flex h-11 w-11 items-center justify-center rounded-2xl border border-white/10 bg-white/[0.04] text-white/70 transition hover:bg-white/[0.08] hover:text-white disabled:cursor-not-allowed disabled:opacity-40"
    >
      {children}
    </button>
  );
}

function MonthSelector({ year, month, onPrev, onNext, onToday, isCurrent }) {
  return (
    <div className="glass-panel inline-flex items-center gap-2 rounded-2xl p-1.5">
      <NavButton onClick={onPrev} label="Mes anterior">
        <ChevronLeftIcon />
      </NavButton>
      <div className="min-w-[140px] px-2 text-center sm:min-w-[180px]">
        <p className="font-serif text-lg tracking-tight">
          <span className="italic text-gradient">{formatMonthYear(year, month)}</span>
        </p>
      </div>
      <NavButton onClick={onNext} label="Mes siguiente">
        <ChevronRightIcon />
      </NavButton>
      {!isCurrent && (
        <button
          type="button"
          onClick={onToday}
          className="ml-1 inline-flex h-10 items-center gap-1.5 rounded-2xl border border-violet-300/30 bg-violet-300/[0.08] px-3 text-[11px] font-mono uppercase tracking-[0.18em] text-violet-100 transition hover:bg-violet-300/[0.16]"
        >
          <TodayIcon />
          Hoy
        </button>
      )}
    </div>
  );
}

export default MonthSelector;